import Link from 'next/link';
import React from 'react';
import * as Styled from './styles';

export const TopNavbarLinks: React.FC<{
  isChatSidebarOpen: boolean;
  hideStake?: boolean;
}> = ({ isChatSidebarOpen, hideStake }) => {
  return (
    <>
      {!isChatSidebarOpen && (
        <>
          <Styled.NavTextLink>
            <Styled.NavbarMenuItemsWrapper>
              <Styled.MenuItem href={'/about'} target="_blank">
                About
              </Styled.MenuItem>
            </Styled.NavbarMenuItemsWrapper>
          </Styled.NavTextLink>
          {/* <Styled.NavTextLink>
            <Styled.NavbarMenuItemsWrapper className={'about-link'}>
              <Styled.MenuItem href="/blog" target="_blank">
                Blog
              </Styled.MenuItem>
            </Styled.NavbarMenuItemsWrapper>
          </Styled.NavTextLink> */}
          {!hideStake && (
            <Styled.NavTextLink>
              <Styled.NavbarMenuItemsWrapper className={'about-link'}>
                <Link href={'/farming'} passHref legacyBehavior>
                  <Styled.MenuItem>Stake</Styled.MenuItem>
                </Link>
              </Styled.NavbarMenuItemsWrapper>
            </Styled.NavTextLink>
          )}
        </>
      )}
    </>
  );
};
